const initialState = {
  isLoading: null,
  isSuccess: null,
  isError: null,
};

export default initialState;
